export default __webpack_public_path__ + "static/media/Karol_0_25.515267ed.jpg";